import { Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef,
	QueryList, ViewChildren,
	AfterViewChecked,
	ChangeDetectorRef,
	NgZone } from '@angular/core';
import {
	FormArray,
	FormControl,
	FormGroup,
	FormBuilder,
	Validators,
	FormsModule,
	ReactiveFormsModule
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgIf, NgFor, NgClass, DecimalPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileDescriptor, FileUploadModule } from '@copo/file-upload-new';

import { TranslationService } from '../../../../shared/services/translation.service';
import { DialogFileUploadComponent }
	from '../dialog-file-upload/dialog-file-upload.component';
import { UNDERSCORE } from '../../../../shared/utils/constant';
import { FastLaneWizardStep } from '../../../models/fastlane-wizard-state';
import { FormFastLane } from '../../../models/form-fastlane';
import { FastLaneRequestAttachment, FastLaneRequestAttachmentForm,
	FastLaneItem } from '../../../models/fastlane.model';
import {
	formValues, coilList, innerDiameterList, unitListForCoil, SESSION_UPDATED,
	unitListForSheet, unitListForBlank, FORM_COIL, FORM_SLITTING_COIL,
	FORM_SHEET, FORM_BLANK, UNIT_TONS, UNIT_SHEET, UNIT_M2, SHIP_TO_CUSTOM,
	UNIT_BLANKS, currencyList, NONE_CODE, REMOVE_MIN_COUNT, DUPLICATE_MAX_COUNT,
	SHIP_TO_LATER,
} from '../../../models/fastlane-list';
import { FastLaneWizardStepperService } from '../../../services/fastlane-wizard-stepper.service';
import { FastLaneWizardService } from '../../../services/fastlane-wizard.service';
import { FastLaneService } from '../../../services/fastlane.service';
import { WizardPageContent } from '../wizard-page-content';
import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { InputNumberDirective } from '../../../../shared/directives/input-number.directive';
import { FocusMeDirective } from '../../../../shared/directives/focus-me.directive';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { SortOptionsPipe } from '../../../../shared/pipes/sorting.pipe';
import { BocClient } from '../../../../shared/models/boc-client-transac';
import { SoldToRelationshipGroup } from '../../../../shared/models/service';
import {
	SnackbarSubmissionFeedbackComponent
} from '../../../../shared/components/snackbar-submission-feedback/snackbar-submission-feedback.component';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';
import { SubmitDialogComponent } from '../../../../shared/components/submit-dialog/submit-dialog.component';
import { AttachmentService } from '../../../services/fastlane-attachment-service';

@Component({
	selector: 'copo-step-details',
	templateUrl: './step-details.component.html',
	styleUrl: './step-details.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,
		NgIf,

		MatTooltipModule,

		MatButtonModule,
		FocusMeDirective,
		MatIconModule,

		MatFormFieldModule,
		FormsModule,
		ReactiveFormsModule,
		NgFor,
		NgClass,

		MatInputModule,

		MatSelectModule,

		MatOptionModule,
		InputNumberDirective,

		MatMenuModule,
		MatExpansionModule,
		MatDividerModule,
		DecimalPipe,
		NumberPipe,
		FileUploadModule,
		SafeUrlPipe,
		SortOptionsPipe,
		LoadingSpinnerComponent
	],
})

export class StepDetailsComponent extends WizardPageContent implements OnDestroy, OnInit,
AfterViewChecked {
	@ViewChild('attachmentDiv', { read: ElementRef }) attachmentDiv!: ElementRef<HTMLElement>;
	@ViewChildren('rows') rows!: QueryList<ElementRef<HTMLElement>>;

	readonly form: FormFastLane;
	productFormGroup!: FormGroup;
	readonly UNDERSCORE = UNDERSCORE;
	soldto?: string;
	description?: string | undefined;
	requestName?: string | undefined;
	shipto = '';
	customDestination = '';
	shipToCustom = '';
	shipToPerson = '';
	shipToContact = '';
	bocs?: Map<string, BocClient>;
	userBocData?: SoldToRelationshipGroup[];
	isExpanded: boolean[] = [];
	validInputErroMsg = 'Please enter a valid input';
	currency?: string;
	sub: Subscription | undefined;
	dialogAfterCloseSub: Subscription | undefined;
	dialogBeforeCloseSub: Subscription | undefined;
	uploadFileCountSub: Subscription | undefined;
	config = { codeProp: 'value', valueProp: 'display' };
	isLoading = false;
	isRenderingForExcelUpload = false;
	submitDialog: MatDialogRef<SubmitDialogComponent> | undefined;
	transKeyMapResponse: Map<string, Map<string, string>> = new Map<string, Map<string, string>>();
	readonly AVG_DENSITY_OF_STEEL = 7.85;
	private readonly VIEW_STEP_NUM = 1;
	private fileUploadCount = 0;

	constructor(
		public fb: FormBuilder,
		private readonly fastlaneWizardService: FastLaneWizardService,
		private readonly fastlaneStepperService: FastLaneWizardStepperService,
		private readonly fastlaneService: FastLaneService,
		private readonly translationService: TranslationService,

		private readonly dialog: MatDialog,

		private readonly snackBar: MatSnackBar,
		private readonly attachmentService: AttachmentService,

		private readonly cdr: ChangeDetectorRef,
		readonly ngZone: NgZone
	) {
		super(FastLaneWizardStep.ITEMSDETAILS, fastlaneWizardService.getState());
		this.form = this.fastlaneWizardService.getStateFastLaneForm();
		this.initializeProductSpecifications();
		for (let i = 0; i < 100; i++) {
			this.isExpanded[i] = true;
		}
		this.uploadFileCountSub = this.attachmentService.uploadAttachmentObs.subscribe(fileCountCompleted => {
			this.fileUploadCount += fileCountCompleted;
		});
	}

	get productResultControl() {
		return (<FormArray> this.productFormGroup.controls['productSpecifications']).controls;
	}

	get productFormArray() {
		return <FormArray> this.productFormGroup.get('productSpecifications');
	}

	getUnitList(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const orderTrackingFormControl = <FormControl> controlArray.controls[formIndex].get('form');
		switch (orderTrackingFormControl.value) {
		case FORM_COIL:
		case FORM_SLITTING_COIL:
			return unitListForCoil;
		case FORM_SHEET:
			return unitListForSheet;
		case FORM_BLANK:
			return unitListForBlank;
		}
		return unitListForCoil;
	}

	initializeProductSpecifications() {
		if (this.fastlaneService.productFormGroup) {
			this.productFormGroup = this.fastlaneService.productFormGroup;
			this.updateValidators();
			this.markAsUntouched();
		} else {
			this.productFormGroup = new FormGroup({
				productSpecifications: new FormArray([]),
			});
			this.fastlaneService.productFormGroup = this.productFormGroup;
		}
	}

	addItem() {
		if (this.productFormArray.length < 100) {
			const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
			const fastlaneItem: FastLaneItem = {
				protoTypeRef: '',
				itemNumber: '',
				status: '',
				name: '',
				steelgrade: '',
				form: FORM_COIL,
				thickness: 0,
				width: 0,
				length: 0,
				quantity: 0,
				quantityUnit: UNIT_TONS,
				blankWeight: 0,
				coating: '',
				coilAxis: 'None',
				oiling: '',
				innerDiameter: 'None',
				maxOutsideDiameter: 0,
				additionalItemInfo: '',
				rddType: '2',
				rddDate: '',
				rddDisplay: '',
				transportMode: 'None',
				incoterms: 'None',
				plant: ' ',
				totalWeight: 0,
				shipTo: <string> this.form.getFormShipTo().value,
				shipToCustom: <string> this.form.getFormShipToCustom().value,
				shipToPerson: <string> this.form.getFormShipToPerson().value,
				shipToContact: <string> this.form.getFormShipToContact().value
			};
			control.push(this.fastlaneService.createFastlaneFormGroup(fastlaneItem));
		}
	}

	ngOnInit() {
		const soldtoShiptoList = this.fastlaneService.filteredSoldtoShiptoList;
		const selSoldtoId = <string> this.form.getFormSoldTo().value;
		const selShiptoId = <string> this.form.getFormShipTo().value;

		this.description = <string> this.form.getFormDescription().value;
		this.requestName = <string> this.form.getFormCustomerRequestName().value;
		const shipToList = this.fastlaneService.filterShiptoList;
		if (selShiptoId === SHIP_TO_LATER) {
			this.shipto = this.translationService.getTR('fastlane.wizard.decide.later');
		} else if (selShiptoId === SHIP_TO_CUSTOM) {
			this.shipToCustom = <string> this.form.getFormShipToCustom().value;
			this.shipToPerson = <string> this.form.getFormShipToPerson().value;
			this.shipToContact = <string> this.form.getFormShipToContact().value;
			this.customDestination = `${ this.shipToCustom } ${ this.shipToPerson } ${ this.shipToContact }`;
			this.shipto = this.translationService.getTR('fastlane.wizard.custom.destination');
		} else if (shipToList) {
			for (const shipTo of shipToList) {
				if (shipTo.businessId === selShiptoId) {
					this.shipto = `${ shipTo.name } - ${ shipTo.city }`;
				}
			}
		}
		if (soldtoShiptoList) {
			const selectedSoldtoList = soldtoShiptoList.filter(v => v.businessId === selSoldtoId);
			for (const soldtoList of selectedSoldtoList) {
				this.soldto = `${ soldtoList.name } - ${ soldtoList.city }`;
			}
		}

		this.fastlaneStepperService.onStepChanged.emit({ step: this.VIEW_STEP_NUM });

		const currencyCode = <string> this.form.getFormCurrency().value;
		const currencyCodeValue = currencyList.find(x => x.code === currencyCode);
		if (currencyCodeValue) {
			this.currency = `${ currencyCodeValue.code }  -  ${ currencyCodeValue.description }`;
		}
		if (this.productFormArray.length <= 0) {
			this.addItem();
		}
		if (!this.transKeyMapResponse.size) {
			this.isLoading = true;
			this.getTranslation()
				.then(() => {
					this.isLoading = false;
				})
				.catch((error: unknown) => {
					console.error(error);
				});
		}
	}

	ngAfterViewChecked(): void {
		if (this.isRenderingForExcelUpload) {
			this.isRenderingForExcelUpload = false;
			this.renderExcelProcessingMessage();
			this.cdr.detectChanges();
		}
	}

	ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}
		if (this.dialogBeforeCloseSub) {
			this.dialogBeforeCloseSub.unsubscribe();
		}

		if (this.uploadFileCountSub) {
			this.uploadFileCountSub.unsubscribe();
		}
	}

	updateValidators() {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		for (let i = 0; i < this.productFormArray.length; i++) {
			controlArray.controls[i].get('shipToCustom')?.setValidators([]);
			controlArray.controls[i].get('shipToCustom')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToPerson')?.setValidators([]);
			controlArray.controls[i].get('shipToPerson')?.updateValueAndValidity();
			controlArray.controls[i].get('shipToContact')?.setValidators([]);
			controlArray.controls[i].get('shipToContact')?.updateValueAndValidity();
		}
	}

	checkError(): boolean {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		if (controlArray.controls.length === 0 || this.fileUploadCount > 0) {
			return true;
		}
		let indexToScroll = -1;
		let i = 0;
		for (const control of controlArray.controls) {
			if (control.invalid) {
				control.markAllAsTouched();
				control.updateValueAndValidity();
				if (indexToScroll === -1) {
					indexToScroll = i;
				}
			}
			i++;
		}
		const rowItems = this.rows.toArray();
		if (indexToScroll !== -1) {
			if (rowItems[indexToScroll]) {
				rowItems[indexToScroll].nativeElement.scrollIntoView();
			}
			return true;
		}
		return false;
	}

	markAsUntouched() {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		for (const control of controlArray.controls) {
			control.markAsUntouched();
		}
	}

	getFormValues() {
		return formValues;
	}

	getCoilList() {
		return coilList;
	}

	getInnerDiameterList() {
		return innerDiameterList;
	}

	getTooltipDescriptionText(tooltipText: string) {
		if (tooltipText && tooltipText.length > 40) {
			const textArray = tooltipText.match(/.{1,40}/g);
			return textArray ? textArray.join('\n') : tooltipText;
		}
		return tooltipText;
	}

	getCustomShipToTooltipText() {
		let responseText;
		if (this.shipToCustom && this.shipToCustom.length > 40) {
			const textArray = this.shipToCustom.match(/.{1,40}/g);
			responseText = textArray ? textArray.join('\n') : this.shipToCustom;
		} else {
			responseText = this.shipToCustom;
		}
		if (this.shipToPerson && this.shipToPerson.length > 40) {
			const textArray = this.shipToPerson.match(/.{1,40}/g);
			responseText = `${ responseText } \n ${ textArray ? textArray.join('\n') : this.shipToPerson }`;
		} else {
			responseText = `${ responseText } \n ${ this.shipToPerson }`;
		}
		if (this.shipToContact && this.shipToContact.length > 40) {
			const textArray = this.shipToContact.match(/.{1,40}/g);
			responseText = `${ responseText } \n ${ textArray ? textArray.join('\n') : this.shipToContact } `;
		} else {
			responseText = `${ responseText } \n ${ this.shipToContact }`;
		}
		return responseText;
	}

	getValidInputErroMsg() {
		return this.validInputErroMsg;
	}

	getDecimalPoinforQuantity(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const unitControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
		if (unitControl.value === UNIT_TONS
			|| unitControl.value === UNIT_M2) {
			return 3;
		}
		return 0;
	}

	updateQuantityField(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const control = <FormControl> controlArray.controls[formIndex].get('quantity');
		const decimalPointLimit = this.getDecimalPoinforQuantity(formIndex);
		if (decimalPointLimit > 0) {
			const stringValue = String(control.value);
			if (stringValue.includes('.')) {
				const arr = stringValue.split('.');
				if (arr.length > 0) {
					let valueAfterDecimalPoint = '';
					if (arr.length > 1 && arr[1].length > 0) {
						valueAfterDecimalPoint = arr[1].slice(0, decimalPointLimit);
					}
					control.setValue(Number.parseFloat(
						`${ arr[0] }.${ valueAfterDecimalPoint }`
					));
				}
			}
		} else {
			const stringValue = String(control.value);
			if (stringValue.includes('.')) {
				control.setValue(Number.parseInt(stringValue, 10));
			}
		}
	}

	isFormBlankSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		const isSelected = Boolean(fieldControl.value === FORM_BLANK);
		if (!isSelected) {
			this.resetControl('blankWeight', <FormControl> controlArray.controls[formIndex]);
		}
		return isSelected;
	}

	isSheetSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		const isSelected = Boolean(fieldControl.value === FORM_SHEET);
		if (!isSelected) {
			this.resetControl('sheetWeightKg', <FormControl> controlArray.controls[formIndex]);
			this.resetControl('length', <FormControl> controlArray.controls[formIndex]);
		}
		return isSelected;
	}

	isSheetWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
		return fieldControl.value === UNIT_SHEET;
	}

	isSelectedAndNotFormBlanks(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		return Boolean(fieldControl.value && fieldControl.value !== FORM_BLANK);
	}

	isCoilOrSlittingCoilSelected(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		const isSelected = Boolean(fieldControl.value === FORM_COIL || fieldControl.value === FORM_SLITTING_COIL);
		if (!isSelected) {
			controlArray.controls[formIndex].get('innerDiameter')?.patchValue('None');
			this.resetControl('maxOutsideDiameter', <FormControl> controlArray.controls[formIndex]);
		}
		return isSelected;
	}

	resetControl(fieldName: string, control: FormControl) {
		control.get(fieldName)?.setValue('');
	}

	defaultexpandcheck(index: number) {
		return index === 0;
	}

	expandPanel(index: number) {
		this.isExpanded[index] = !this.isExpanded[index];
	}

	getExpandPanelStatus(index: number) {
		return this.isExpanded[index];
	}

	checkItemList() {
		return this.productFormArray.length > 0;
	}

	getOrderTrackingForm(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		return <string> fieldControl.value;
	}

	onOrderTrackingFormChange(formIndex: number, value: string) {
		if (value) {
			const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
			const quantityUnitControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
			const widthControl = <FormControl> controlArray.controls[formIndex].get('width');
			const lengthControl = <FormControl> controlArray.controls[formIndex].get('length');
			const blankWeightControl = <FormControl> controlArray.controls[formIndex].get('blankWeight');
			switch (value) {
			case FORM_COIL:
			case FORM_SLITTING_COIL:
				quantityUnitControl.setValue(UNIT_TONS);
				widthControl.setValidators([
					Validators.required,
					Validators.min(1)
				]);
				widthControl.updateValueAndValidity();
				lengthControl.setValidators([]);
				lengthControl.updateValueAndValidity();
				blankWeightControl.setValidators([]);
				blankWeightControl.updateValueAndValidity();
				break;
			case FORM_SHEET:
				quantityUnitControl.setValue(UNIT_SHEET);
				widthControl.setValidators([
					Validators.required,
					Validators.min(1)
				]);
				widthControl.updateValueAndValidity();
				lengthControl.setValidators([
					Validators.required,
					Validators.min(1)
				]);
				lengthControl.updateValueAndValidity();
				blankWeightControl.setValidators([]);
				blankWeightControl.updateValueAndValidity();
				break;
			case FORM_BLANK:
				quantityUnitControl.setValue(UNIT_BLANKS);
				widthControl.setValidators([]);
				widthControl.updateValueAndValidity();
				lengthControl.setValidators([]);
				lengthControl.updateValueAndValidity();
				blankWeightControl.setValidators([
					Validators.required,
					Validators.min(1)
				]);
				blankWeightControl.updateValueAndValidity();
				break;
			}
		}
		this.updateQuantityField(formIndex);
	}

	getUnit(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
		return <string> fieldControl.value;
	}

	getCoilAxis(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('coilAxis');
		return <string> fieldControl.value;
	}

	getCoilInnerDiameter(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('innerDiameter');
		return <string>fieldControl.value;
	}

	getItemNameLength(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('name');
		const name = <string>fieldControl.value;
		return name.length;
	}

	getSteelGradeLength(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('steelgrade');
		const steelgrade = <string>fieldControl.value;
		return steelgrade.length;
	}

	getAdditionalInfoLength(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl>controlArray.controls[formIndex].get('additionalItemInfo');
		const additionalItemInfo = <string>fieldControl.value;
		return additionalItemInfo.length;
	}

	getControl(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		return <FormControl>controlArray.controls[formIndex].get(controlName);
	}

	isThicknessEmpty(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const thicknessControl = <FormControl>controlArray.controls[formIndex].get('thickness');
		return thicknessControl.value === undefined || String(thicknessControl.value).length === 0;
	}

	disableDeleteMenu() {
		return this.productFormArray.length < REMOVE_MIN_COUNT;
	}

	disableDuplicateMenu() {
		return this.productFormArray.length >= DUPLICATE_MAX_COUNT;
	}

	removeProductResult(index: number) {
		if (this.productFormArray.length >= REMOVE_MIN_COUNT) {
			const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
			control.removeAt(index);
		}
	}

	resetProduct(index: number) {
		const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
		control.controls[index].get('name')?.setValue('');
		control.controls[index].get('steelgrade')?.setValue('');
		control.controls[index].get('form')?.setValue(FORM_COIL);
		control.controls[index].get('quantityUnit')?.setValue(UNIT_TONS);
		control.controls[index].get('thickness')?.setValue('');
		control.controls[index].get('width')?.setValue('');
		control.controls[index].get('quantity')?.setValue('');
		control.controls[index].get('coating')?.setValue('');
		control.controls[index].get('coilAxis')?.setValue(NONE_CODE);
		control.controls[index].get('oiling')?.setValue('');
		control.controls[index].get('innerDiameter')?.setValue(NONE_CODE);
		control.controls[index].get('maxOutsideDiameter')?.reset();
		control.controls[index].get('additionalItemInfo')?.setValue('');
		control.controls[index].get('sheetWeightKg')?.setValue('');
		control.controls[index].get('totalWeight')?.setValue('');
		control.controls[index].get('length')?.setValue('');
		control.controls[index].get('blankWeight')?.setValue('');
		control.controls[index].get('attachmentErrorMessages')?.setValue('');
		control.controls[index].get('shipTo')?.setValue(this.form.getFormShipTo().value);
		control.controls[index].get('shipToContact')?.setValue(this.form.getFormShipToContact().value);
		control.controls[index].get('shipToPerson')?.setValue(this.form.getFormShipToPerson().value);
		control.controls[index].get('shipToCustom')?.setValue(this.form.getFormShipToCustom().value);
		const attachmentFormArray = <FormArray> control.controls[index].get('fastLaneRequestItemAttachments');
		attachmentFormArray.clear();
		control.controls[index].setErrors(null);
		control.controls[index].markAsUntouched();
	}

	duplicateProduct(index: number) {
		if (this.productFormArray.length < DUPLICATE_MAX_COUNT) {
			const control = <FormArray> this.productFormGroup.controls['productSpecifications'];
			const newProductFormGroup = new FormGroup(this.productFormGroup.controls);
			const newControl = <FormArray>newProductFormGroup.get('productSpecifications');
			const nameControl = <FormControl>newControl.controls[index].get('name');
			const steelgradeControl = <FormControl>newControl.controls[index].get('steelgrade');
			const formControl = <FormControl>newControl.controls[index].get('form');
			const quantityUnitControl = <FormControl>newControl.controls[index].get('quantityUnit');
			const thicknessControl = <FormControl>newControl.controls[index].get('thickness');
			const widthControl = <FormControl>newControl.controls[index].get('width');
			const quantityControl = <FormControl>newControl.controls[index].get('quantity');
			const coatingControl = <FormControl>newControl.controls[index].get('coating');
			const coilAxisControl = <FormControl>newControl.controls[index].get('coilAxis');
			const oilingControl = <FormControl>newControl.controls[index].get('oiling');
			const innerDiameterControl = <FormControl>newControl.controls[index].get('innerDiameter');
			const maxOutsideDiameterControl = <FormControl>newControl.controls[index].get('maxOutsideDiameter');
			const additionalInfoControl = <FormControl>newControl.controls[index].get('additionalItemInfo');
			const sheetWeightKgControl = <FormControl>newControl.controls[index].get('sheetWeightKg');
			const totalWeightControl = <FormControl>newControl.controls[index].get('totalWeight');
			const lengthControl = <FormControl>newControl.controls[index].get('length');
			const blankWeightControl = <FormControl>newControl.controls[index].get('blankWeight');
			const shipToControl = <FormControl>newControl.controls[index].get('shipTo');
			const shipToCustomControl = <FormControl>newControl.controls[index].get('shipToCustom');
			const shipToPersonControl = <FormControl>newControl.controls[index].get('shipToPerson');
			const shipToContactControl = <FormControl>newControl.controls[index].get('shipToContact');
			const newFormGroup = this.fb.group({
				name: new FormControl(nameControl.value, {
					validators: [
						Validators.required,
						Validators.maxLength(80)
					]
				}),
				steelgrade: new FormControl(steelgradeControl.value, {
					validators: [
						Validators.required,
						Validators.maxLength(255)
					]
				}),
				form: new FormControl(formControl.value, {
					validators: [Validators.required]
				}),
				quantityUnit: new FormControl(quantityUnitControl.value, { validators: [Validators.required] }),
				thickness: new FormControl(thicknessControl.value, {
					validators: [
						Validators.required,
						Validators.max(999),
						Validators.min(0.1)
					]
				}),
				width: new FormControl(widthControl.value, {
					validators: [
						Validators.required,
						Validators.max(999_999_999),
						Validators.min(1)
					]
				}),
				quantity: new FormControl(quantityControl.value, {
					validators: [
						Validators.required,
						Validators.max(99_999_999),
						Validators.min(1)
					]
				}),
				coating: new FormControl(coatingControl.value, {
					validators: [
						Validators.required,
						Validators.maxLength(50)
					]
				}),
				coilAxis: new FormControl(coilAxisControl.value, { validators: [] }),
				oiling: new FormControl(oilingControl.value, { validators: [Validators.maxLength(50)] }),
				innerDiameter: new FormControl(innerDiameterControl.value, { validators: [] }),
				maxOutsideDiameter: new FormControl(
					maxOutsideDiameterControl.value,
					{ validators: [Validators.min(1)] }
				),
				additionalItemInfo: new FormControl(additionalInfoControl.value),
				length: new FormControl(lengthControl.value, {
					validators: [
						Validators.max(999_999_999),
						Validators.min(1)
					]
				}),
				blankWeight: new FormControl(blankWeightControl.value, {
					validators: [
						Validators.max(99_999_999),
						Validators.min(1)
					]
				}),
				totalWeight: new FormControl(totalWeightControl.value, { validators: [] }),
				sheetWeightKg: new FormControl(sheetWeightKgControl.value, { validators: [] }),
				rddType: new FormControl('2', { validators: [] }),
				rddDate: new FormControl(''),
				transportMode: new FormControl('Truck', { validators: [] }),
				incoterms: new FormControl('None', { validators: [Validators.required] }),
				packing: new FormControl('', { validators: [] }),
				plant: new FormControl(' ', { validators: [] }),
				fastLaneRequestItemAttachments: this.fb.array([]),
				attachmentErrorMessages: new FormControl('', { validators: [] }),
				shipTo: new FormControl(shipToControl.value, { validators: [] }),
				shipToCustom: new FormControl(shipToCustomControl.value, { validators: [] }),
				shipToPerson: new FormControl(shipToPersonControl.value, { validators: [] }),
				shipToContact: new FormControl(shipToContactControl.value, { validators: [] }),
			});
			control.push(newFormGroup);
		}
	}

	spaceHandle(formIndex: number, controlName: string) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const control = <FormControl>controlArray.controls[formIndex].get(controlName);
		const stringValue = <string> control.value;
		control.setValue(stringValue.trim());
	}

	calculateSheetWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('form');
		const width = <FormControl> controlArray.controls[formIndex].get('width');
		const quantityUnitControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
		const length = <FormControl> controlArray.controls[formIndex].get('length');
		const thickness = <FormControl> controlArray.controls[formIndex].get('thickness');
		const sheetWeightKgControl = <FormControl> controlArray.controls[formIndex].get('sheetWeightKg');
		const validValue = width.value > 0 && thickness.value > 0 && length.value > 0;
		let sheetWeightKg;
		if ((fieldControl.value === FORM_SHEET || quantityUnitControl.value === UNIT_TONS) && validValue) {
			sheetWeightKg = this.roundNumericValues((this.AVG_DENSITY_OF_STEEL * width.value
				* thickness.value * length.value) / 1_000_000);
		}
		sheetWeightKgControl.setValue(sheetWeightKg);
		return Number(sheetWeightKg);
	}

	calculateTotalWeight(formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const fieldControl = <FormControl> controlArray.controls[formIndex].get('quantityUnit');
		const quantitycontrol = <FormControl> controlArray.controls[formIndex].get('quantity');
		const thicknessControl = <FormControl> controlArray.controls[formIndex].get('thickness');
		const blankWeightControl = <FormControl> controlArray.controls[formIndex].get('blankWeight');
		const totalWeightControl = <FormControl> controlArray.controls[formIndex].get('totalWeight');

		let totalWeight;
		switch (fieldControl.value) {
		case UNIT_SHEET:
			if (quantitycontrol.value > 0) {
				const sheetWeightKg = this.calculateSheetWeight(formIndex);
				totalWeight = this.roundNumericValues((quantitycontrol.value * sheetWeightKg) / 1000);
			}
			break;
		case UNIT_TONS:
			if (quantitycontrol.value > 0) {
				totalWeight = Number(quantitycontrol.value);
			}
			break;
		case UNIT_M2:
			if (thicknessControl.value > 0 && quantitycontrol.value > 0) {
				totalWeight = this.roundNumericValues((quantitycontrol.value
					* this.AVG_DENSITY_OF_STEEL * thicknessControl.value) / 1000);
			}
			break;
		case UNIT_BLANKS:
			if (blankWeightControl.value > 0 && quantitycontrol.value > 0) {
				totalWeight = this.roundNumericValues(quantitycontrol.value * blankWeightControl.value);
			}
			break;
		}
		totalWeightControl.setValue(totalWeight);
		return Number(totalWeight);
	}

	roundNumericValues(value: number) {
		return Math.round((value + Number.EPSILON) * 100) / 100;
	}

	async addAttachments(events: FileList, formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentFormGroups = <FormArray> controlArray.controls[formIndex].get('fastLaneRequestItemAttachments');
		const attachmentErrorControl = <FormControl> controlArray.controls[formIndex].get('attachmentErrorMessages');
		attachmentErrorControl.setValue('');
		const files = Array.from(events);
		await this.attachmentService.uploadFiles(files, attachmentFormGroups, attachmentErrorControl);
	}

	hasRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		return attachmentFormGroups.length > 0;
	}

	getRequestAttachments() {
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		const attachments: FastLaneRequestAttachment[] = [];
		for (const itemRow of attachmentFormGroups.value) {
			const fastLaneAttachment = (<FastLaneRequestAttachmentForm>
				itemRow).fastlaneAttachment;
			attachments.push(fastLaneAttachment);
		}
		return attachments;
	}

	removeAttachmentEvent(file: FileDescriptor, formIndex: number) {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentFormGroups = <FormArray>controlArray.controls[formIndex].get('fastLaneRequestItemAttachments');
		this.attachmentService.removeAttachment(<FastLaneRequestAttachment> file.data, attachmentFormGroups);
	}

	fileErrors(formIndex: number): string[] {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentErrorControl = <FormControl> controlArray.controls[formIndex].get(
			'attachmentErrorMessages'
		);
		return [<string> attachmentErrorControl.value];
	}

	files(formIndex: number): FileDescriptor[] {
		const controlArray = <FormArray> this.productFormGroup.get('productSpecifications');
		const attachmentFormGroups = <FormArray> controlArray.controls[formIndex].get('fastLaneRequestItemAttachments');
		const fileDescriptorArray: FileDescriptor[] = [];
		for (const itemRow of attachmentFormGroups.value) {
			const attachmentFormValue = <FastLaneRequestAttachmentForm> itemRow;
			const attachment = attachmentFormValue.fastlaneAttachment;
			const fileDescriptor: FileDescriptor = { localFile: attachment.localFile,
				error: Boolean(attachment.error),
				progress: attachment.progress,
				type: attachment.type,
				name: attachment.fileName,
				url: attachment.localUrl,
				data: attachment };
			fileDescriptorArray.push(fileDescriptor);
		}
		return fileDescriptorArray;
	}

	openFileImportDialog() {
		const dialogRef = this.dialog.open(DialogFileUploadComponent, {
			data: {
				title: 'fastlane.import.popup.title',
				content1: 'fastlane.import.popup.text.1',
				content2: 'fastlane.import.popup.text.2',
				content3: 'fastlane.import.popup.text.3',
				content4: 'fastlane.import.popup.text.4',
				content5: 'fastlane.import.popup.text.5',
				resultLabel: 'fastlane.file.import.result.label',
				button: 'fastlane.file.import.validate',
				transKeyMapResponse: this.transKeyMapResponse
			},
		});

		this.dialogBeforeCloseSub = dialogRef.beforeClosed().subscribe(sessionUpdated => {
			if (sessionUpdated === SESSION_UPDATED && this.fastlaneService.productFormGroup) {
				(<FormArray> this.productFormGroup.controls['productSpecifications']).clear();
				this.ngZone.run(() => {
					this.submitDialog = this.dialog.open<SubmitDialogComponent, undefined, number>(
						SubmitDialogComponent,
						{ panelClass: 'copo-offer-dialog', disableClose: true }
					);
					this.submitDialog.componentInstance.progressMessage =
						this.translationService.getTR('fastlane.file.import.progressMessage');
					this.submitDialog.componentInstance.waitMessage =
						this.translationService.getTR('wait.message.fastlane');
				});
			}
		});

		this.dialogAfterCloseSub = dialogRef.afterClosed().subscribe(sessionUpdated => {
			if (sessionUpdated === SESSION_UPDATED && this.fastlaneService.productFormGroup) {
				setTimeout(() => {
					this.isRenderingForExcelUpload = true;
					if (this.fastlaneService.productFormGroup) {
						this.productFormGroup = this.fastlaneService.productFormGroup;
					}
				}, 1000);
			}
		});
	}

	renderExcelProcessingMessage() {
		if (this.submitDialog) {
			this.submitDialog.close();
		}
		this.snackBar.openFromComponent(
			SnackbarSubmissionFeedbackComponent,
			{
				data: {
					hideResponseDetails: true,
					isThanksMessage: true,
					isThanksMessage2: true,
					isRedirectLink: false,
					submitThanksMessage: this.translationService
						.getTR('fastlane.template.upload.confirmation.text1'),
					submitThanksMessage2: this.translationService
						.getTR('fastlane.template.upload.confirmation.text2'),
				},
				duration: 20_000,
				panelClass: ['copo-snackbar-submission-feedback-container']
			}
		);
	}

	downloadTemplate() {
		return this.fastlaneService.downloadTemplate();
	}

	async getTranslation() {
		try {
			await this.fastlaneService.getTemplateFieldTranslation()
				.then(res => {
					const response = new Map<string, Map<string, string>>(Object.entries(res));
					for (const transVal of response) {
						const transObj = new Map<string, string>(Object.entries(transVal[1]));
						this.transKeyMapResponse.set(transVal[0], transObj);
					}
				});
		} catch (err) {
			console.error('Error while adding the parameter value', err);
		}
	}
}
